import { HFlow, Icon, PagedTable, Tag, Text, Tooltip } from 'bold-ui'
import { ButtonLink } from 'components/route'
import { TableBox } from 'components/table/TableBox'
import { usePagedTableProps } from 'components/table/usePagedTableProps'
import { useEquipeTableQuery } from 'graphql/hooks.generated'
import { EquipesConnectionInput, EquipeTableQuery } from 'graphql/types.generated'
import { useRouter } from 'hooks/useRouter'
import React, { useState } from 'react'
import { capitalize } from 'util/strConversor'
import { EquipeTableFilter } from 'view/equipe/list/EquipeTableFilter'

export type ItemType = EquipeTableQuery['unidadeSaude']['equipes']['content'][0]

export interface EquipeTableProps {
  unidadeSaudeId: ID
}

export function EquipeTable(props: EquipeTableProps) {
  const { unidadeSaudeId } = props
  const { match } = useRouter()

  const [filter, setFilter] = useState<EquipesConnectionInput>({
    mostrarInativas: false,
    pageParams: {
      sort: ['nome'],
    },
  })

  const {
    data: { unidadeSaude },
    loading,
  } = useEquipeTableQuery({
    variables: { unidadeSaudeId, input: filter },
  })

  const renderNome = (row: ItemType) => {
    return (
      <HFlow hSpacing={0.5} alignItems='center'>
        <Text>{capitalize(row.nome)}</Text>
        {!row.ativo && <Tag>Inativa</Tag>}
      </HFlow>
    )
  }

  const renderIne = (row: ItemType) => {
    return <Text>{row.ine}</Text>
  }

  const renderArea = (row: ItemType) => {
    return <Text>{row.area}</Text>
  }

  const renderTipoEquipe = (row: ItemType) => {
    return <Text>{row.tipoEquipe.sigla + ' - ' + capitalize(row.tipoEquipe.nome)}</Text>
  }

  const renderButtons = (row: ItemType) => {
    return (
      <Tooltip text='Visualizar'>
        <ButtonLink to={`${match.url}/${row.id}`} size='small' skin='ghost'>
          <Icon icon='zoomOutline' />
        </ButtonLink>
      </Tooltip>
    )
  }

  const tableProps = usePagedTableProps({
    loading,
    onChange: setFilter,
    result: unidadeSaude && unidadeSaude.equipes,
  })

  return (
    <TableBox header={<EquipeTableFilter initialFilter={filter} onChange={setFilter} />}>
      <PagedTable<ItemType>
        {...tableProps}
        columns={[
          { name: 'nome', header: 'Nome', render: renderNome, sortable: true },
          { name: 'ine', header: 'INE', render: renderIne },
          { name: 'area', header: 'Área', render: renderArea },
          { name: 'tipoEquipe', header: 'Tipo de equipe', render: renderTipoEquipe },
          { name: 'buttons', render: renderButtons, style: { textAlign: 'right' } },
        ]}
      />
    </TableBox>
  )
}
